export default __webpack_public_path__ + "static/media/skorsten-default.46a8856d.jpg";